import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import Card from '../../components/ui/Card';
import { useTranslation } from '../../i18n/LanguageContext';
import {
  IconBuilding,
  IconMapPin,
  IconUsersGroup,
  IconCreditCard,
  IconBell,
  IconHistory,
  IconDatabase,
  IconPlug,
  IconFlask,
  IconShieldCheck,
  IconChartBar,
  IconChevronRight,
} from '@tabler/icons-react';

// Everything under /settings was reachable only by typing the URL — the
// sidebar linked to the Organisation page and nothing else. This lists it.
const GROUPS = [
  {
    titleKey: 'set.group_organisation',
    items: [
      { path: '/settings/organisation', icon: IconBuilding,   labelKey: 'set.org_details',   hintKey: 'set.org_details_hint' },
      { path: '/settings/sites',        icon: IconMapPin,     labelKey: 'dashboard.sites',   hintKey: 'set.sites_hint' },
      { path: '/settings/roles',        icon: IconUsersGroup, labelKey: 'set.roles',         hintKey: 'set.roles_hint' },
      { path: '/settings/billing',      icon: IconCreditCard, labelKey: 'nav.billing',       hintKey: 'set.billing_hint' },
    ],
  },
  {
    titleKey: 'set.group_safety',
    items: [
      { path: '/settings/coshh',            icon: IconFlask,       labelKey: 'upsell.coshh_title', hintKey: 'set.coshh_hint' },
      { path: '/settings/risk-assessments', icon: IconShieldCheck, labelKey: 'upsell.risk_title',  hintKey: 'set.risk_hint' },
    ],
  },
  {
    titleKey: 'set.reports',
    items: [
      { path: '/reports', icon: IconChartBar, labelKey: 'set.reports', hintKey: 'set.reports_hint' },
    ],
  },
  {
    titleKey: 'set.group_system',
    items: [
      { path: '/settings/integrations',  icon: IconPlug,     labelKey: 'set.integrations',       hintKey: 'set.integrations_hint' },
      { path: '/settings/notifications', icon: IconBell,     labelKey: 'profile.notifications',  hintKey: 'set.notifications_hint' },
      { path: '/settings/audit-log',     icon: IconHistory,  labelKey: 'set.audit_log',          hintKey: 'set.audit_log_hint' },
      { path: '/settings/data',          icon: IconDatabase, labelKey: 'set.data',               hintKey: 'set.data_hint' },
    ],
  },
];

export default function SettingsIndex() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { org } = useAuth();

  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 760, margin: '0 auto' }}>
        <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 8 }}>{t('nav.settings')}</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>
          {org?.name || t('set.your_organisation')}
        </p>

        {GROUPS.map(group => (
          <div key={group.titleKey} style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.6, color: 'var(--color-text-tertiary)', marginBottom: 8 }}>
              {t(group.titleKey)}
            </div>
            <Card style={{ padding: 0, overflow: 'hidden' }}>
              {group.items.map((item, i) => {
                const Icon = item.icon;
                return (
                  <div
                    key={item.path}
                    onClick={() => navigate(item.path)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 12,
                      padding: '13px 16px', cursor: 'pointer',
                      borderBottom: i < group.items.length - 1 ? '0.5px solid var(--color-border-light)' : 'none',
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => (e.currentTarget.style.background = 'var(--color-bg-secondary)')}
                    onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
                  >
                    <Icon size={17} color="var(--color-text-tertiary)" stroke={1.5} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 13, color: 'var(--color-text-primary)' }}>{t(item.labelKey)}</div>
                      <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 2 }}>{t(item.hintKey)}</div>
                    </div>
                    <IconChevronRight size={15} color="var(--color-text-tertiary)" stroke={1.5} />
                  </div>
                );
              })}
            </Card>
          </div>
        ))}
      </div>
    </Layout>
  );
}
